###
  Currency widget
###

class INTENT.widgets.Currency

  @ATTR_NAME: "data-widget-currency"

  @ATTR_SAVE: "#{@ATTR_NAME}-save"

  @CLASS_CURRENCY_CONTAINER: "currency-container"
  @CLASS_CURRENCY_INPUT: "currency-input"

  constructor: (@el) ->
    @s = @.constructor
    @save = @el.find "[#{@s.ATTR_SAVE}]"
    @input = @el.find "input"
    @advertiser_id = @el.attr @s.ATTR_NAME

    @save.on "click", @submit

    $("[#{@s.ATTR_NAME}-open-help]").on "click", () =>
      @close_modal()
      $('#helpForm').modal 'show'

  submit: =>
    $.ajax(@get_options()).done @after_submit

  update_elements: (currency) =>
    containers = $ ".#{@s.CLASS_CURRENCY_CONTAINER}"
    inputs_by_class = $ ".#{@s.CLASS_CURRENCY_INPUT}"
    input_by_name = $ 'form input[name="currency"]'

    containers.html currency
    inputs_by_class.val currency
    input_by_name.val currency

  after_submit: (xhr) =>
    unless @get_value() then return false

    @update_elements xhr.currency
    @close_modal()

  get_options: =>
    {
      url: @get_action(),
      type: 'POST',
      data: @get_post_options()
    }

  get_post_options: =>
    {
      id: @advertiser_id,
      currency: @get_value()
    }

  get_action: =>
    "/ajax/update_currency"

  get_value: =>
    @input.filter(":checked").val()

  close_modal: =>
    @el.modal 'hide'

